import React from 'react'
import './User_SetNameState.css'
import '../UserPanel.css'
import team_zoom from '../../../images/tooltip/team_zoom.svg'

class User_SetNameState extends React.Component{
    render() {
        return <div className="user-set-name-status-container">
            <div className='user-header-text'>{this.props.teamname}</div>
            <div className='user-set-name-tooltip-container'>
                <img alt={"icon"} src={team_zoom} className='user-set-name-tooltip-image'/>
                <div className='user-set-name-tooltip-text'>Перейдите в конферен-зал своей команды
                    и придумайте ей название.</div>
            </div>
            <div className='user-set-name-tooltip-container'>
                <div className='user-set-name-tooltip-text'>Сообщите преподавателю название как будете готовы, нажав на кнопку "обратиться за помощью" в Zoom</div>
            </div>
        </div>
    }
}

export default User_SetNameState;
